import component from './WpEmbed.vue'
export default component
